// Slingora: accessory "+ Add" buttons and the shipping-protection toggle.
// Uses the theme's section rendering so the cart drawer refreshes in place.
(() => {
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: SECTIONS, sections_url: window.location.pathname }),
    }).then((r) => r.json());

  const render = async (state) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return (window.location.href = '/cart');
    if (!state || !state.sections) {
      // Response came back without section HTML: fetch the drawer sections directly.
      const res = await fetch(`${window.location.pathname}?sections=${SECTIONS.join(',')}`);
      state = { sections: await res.json() };
    }
    drawer.renderContents(state);
  };

  // Bundle tiers on the product page drive the add-to-cart form quantity.
  const syncBundleQty = (radio) => {
    const scope = radio.closest('.shopify-section') || document;
    const form = scope.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    let qty = form.querySelector('input[name="quantity"]');
    if (!qty) {
      qty = Object.assign(document.createElement('input'), { type: 'hidden', name: 'quantity' });
      form.appendChild(qty);
    }
    qty.value = radio.value;
  };
  const initBundles = () =>
    document.querySelectorAll('[data-sl-bundle] input[name="sl_qty"]:checked').forEach(syncBundleQty);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initBundles) : initBundles();

  // Kit/variant switch: the theme re-renders only price/SKU, so refresh the blocks that depend on the
  // selected variant (in-the-box, specs, bundle tier prices) from the section HTML it already fetched.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      data?.html?.querySelectorAll('[data-sl-sync]').forEach((src) => {
        const dst = document.querySelector(`[data-sl-sync="${src.dataset.slSync}"]`);
        if (!dst) return;
        const qty = dst.querySelector('input[name="sl_qty"]:checked')?.value;
        dst.innerHTML = src.innerHTML;
        const radio = qty && dst.querySelector(`input[name="sl_qty"][value="${qty}"]`);
        if (radio) {
          radio.checked = true;
          syncBundleQty(radio);
        }
      });
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sl-add]');
    if (!btn) return;
    e.preventDefault();
    const select = btn.closest('.sl-upsell-card')?.querySelector('.sl-upsell-card__select');
    const id = Number(select ? select.value : btn.dataset.variantId);
    btn.disabled = true;
    btn.classList.add('loading');
    post('/cart/add.js', { items: [{ id, quantity: 1 }] })
      .then((state) => {
        if (state.status) throw new Error(state.description || state.message);
        // add.js returns the added items; render needs the sections map it also carries
        render(state);
      })
      .catch((err) => console.error('[slingora] add failed:', err.message))
      .finally(() => {
        btn.disabled = false;
        btn.classList.remove('loading');
      });
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-sl-bundle] input[name="sl_qty"]')) return syncBundleQty(e.target);
    const box = e.target.closest('[data-sl-protect]');
    if (!box) return;
    box.disabled = true;
    const req = box.checked
      ? post('/cart/add.js', { items: [{ id: Number(box.dataset.variantId), quantity: 1 }] })
      : post('/cart/change.js', { id: box.dataset.lineKey, quantity: 0 });
    req.then(render, () => render(null)).catch(() => (box.disabled = false));
  });
})();

// Bundle add-ons: when the product form is submitted, first add the ticked add-ons of the
// selected tier, then let the theme's own submit run (it adds the slingshot and opens the drawer).
(() => {
  let addonsDone = false;

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!form.matches?.('form[data-type="add-to-cart-form"]')) return;
      if (addonsDone) {
        addonsDone = false;
        return;
      }
      const scope = form.closest('.shopify-section') || document;
      const tier = scope.querySelector('[data-sl-bundle] input[name="sl_qty"]:checked')?.closest('.sl-bundle__tier');
      const items = [...(tier?.querySelectorAll('[data-sl-addon]:checked') || [])].map((c) => ({
        id: Number(c.dataset.variantId),
        quantity: 1,
      }));
      if (!items.length) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      })
        .catch((err) => console.error('[slingora] add-ons failed:', err))
        .finally(() => {
          addonsDone = true;
          form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
    },
    true
  );
})();

/* Product videos: no download until scrolled near, then play (keeps bandwidth for the main image). */
(() => {
  const init = () => {
    const vids = document.querySelectorAll('[data-sl-lazyvideo] video');
    if (!vids.length) return;
    const start = (v) => { v.preload = 'auto'; v.muted = true; v.play().catch(() => {}); };
    if (!('IntersectionObserver' in window)) return vids.forEach(start);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { start(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '300px 0px' });
    vids.forEach((v) => io.observe(v));
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();

/* Mobile sticky add-to-cart bar: shows while the real Add to cart button is off screen and clicks it. */
(() => {
  const init = () => {
    const btn = document.querySelector('product-info .product-form__submit[name="add"]');
    if (!btn || !('IntersectionObserver' in window)) return;
    const info = btn.closest('product-info');
    const title = info.querySelector('.product__title h1, .product__title h2');
    const bar = document.createElement('div');
    bar.className = 'sl-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="sl-sticky-atc__info"><span class="sl-sticky-atc__title"></span><span class="sl-sticky-atc__price"></span></div><button type="button" class="button button--primary sl-sticky-atc__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    const sbtn = bar.querySelector('button');
    const sync = () => {
      const price = info.querySelector('.price__sale:not([style*="none"]) .price-item--sale, .price .price-item--regular');
      bar.querySelector('.sl-sticky-atc__title').textContent = title ? title.textContent.trim() : '';
      bar.querySelector('.sl-sticky-atc__price').textContent = price ? price.textContent.trim() : '';
      const label = btn.querySelector('span');
      sbtn.textContent = (label || btn).textContent.trim();
      sbtn.disabled = btn.disabled;
    };
    sbtn.addEventListener('click', () => {
      sync();
      if (btn.disabled) return;
      btn.click();
    });
    let inView = true;
    const update = () => {
      const show = !inView && window.scrollY > 120;
      if (show !== bar.classList.contains('is-visible')) sync();
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('sl-sticky-atc-on', show);
    };
    new IntersectionObserver(([e]) => { inView = e.isIntersecting; update(); }).observe(btn);
    window.addEventListener('scroll', update, { passive: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
